import React, { Component } from "react";
import getObj from "lodash/get";
import { connect } from "react-redux";
import { Form, Input, InputNumber, Card, Button, Row, Col, message, Empty, Descriptions, DatePicker, Select } from "antd";
import axios from "services/axios";
import moment from "moment";

const FormItem = Form.Item;
const Option = Select.Option;
const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 },
    md: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 18 },
    md: { span: 16},
  },
};

class OfferingDetail extends Component {
  state = {
    inquiryData: {},
    bookingId: "",
    grade: "",
    licensePlate: "",
    price: "",
    notes: "",
  };

  componentDidMount = async () => {
    try {
      let { id } = this.props.match.params;
      let req = await axios.get(`/car-inquiry/${id}`);
      console.log(req.data)
      this.setState({
        ...req.data.inquiry,
        appraisal: req.data.appraisal,
        supervisor: req.data.supervisor
      });
    } catch (err) {
      console.error(err);
      message.error("Error, Can't fetch inquiry detail");
    }
  };

  handleSubmit(e) {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (err) {
        console.log(err);
      } else {
        axios
          .put(`/car-inquiry/${this.state.id}/deal-nego`, {
            collectionDate: values.collectionDate,
            priceNegotiatorNotes: values.priceNegotiatorNotes,
            priceFromNegotiator: values.priceFromNegotiator,
            TNTFollowUp: values.TNTFollowUp
          })
          .then(inquiry => {
            this.props.history.push("/home/internal-bidding/tnt");
          })
          .catch(err => {
            console.log(err.message);
          });
      }
    });
  }

  saveAsDraft() {
    const { bookingId } = this.state;
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (err) {
      } else {
        axios
          .put(`/car-inquiry/${this.state.id}/deal-nego/save-draft`, { ...values, bookingId })
          .then(inquiry => {
            message.success("Succes save data as draft");
            this.props.history.push("/home/internal-bidding/tnt");
          })
          .catch(err => {
            message.error("Failed save data as draft");
            console.log(err);
          });
      }
    });
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { appraisal, Booking, priceNegotiatorId, PriceNegotiator, supervisor } = this.state;
    return this.state.id ?(
      <Card>
        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Descriptions size="small" title="Car Information" column={1} bordered={true}>
              {[
                "carDetail[7]",
                "carDetail[5]",
                "carDetail[10]",
                "carDetail[11]",
                "carDetail[6]", 
                "carDetail[12]", 
                "carDetail[13]"
              ].map((field, index) => (
                <Descriptions.Item key={index} label={getObj(appraisal, field).fieldName}>
                  {getObj(appraisal, field).value}
                </Descriptions.Item>
              ))}
            </Descriptions>
          </Col>
          <Col xs={24} md={12}>
            <Descriptions size="small" title="Sales Informartion" column={1} bordered={true}>
              <Descriptions.Item label="Nama Sales">  {getObj(Booking, "SalesProfile.name")} </Descriptions.Item>
              <Descriptions.Item label="Nama Cabang"> {getObj(Booking, "SalesProfile.branch")} </Descriptions.Item>
              <Descriptions.Item label="No. Hp"> {getObj(Booking, "SalesProfile.phone")} </Descriptions.Item>
              <Descriptions.Item label="Nama SS"> {supervisor ? supervisor.name : ""} </Descriptions.Item>
            </Descriptions>

            <Descriptions size="small" title="Customer Information" column={1} bordered={true} style={{marginTop: 10}}>
              {["carDetail[0]", "carDetail[2]", "carDetail[1]"].map((field, index) => (
                <Descriptions.Item key={index} label={getObj(appraisal, field).fieldName}>
                  {getObj(appraisal, field).value}
                </Descriptions.Item>
              ))}
            </Descriptions>
          </Col>
        </Row>

        <Row>
          <Card title="Negotiation Form" style={{ marginTop: "30px" }}>
            <Form layout="vertical"  onSubmit={e => this.handleSubmit(e)}>
              <Row gutter={16}>
                <Col xs={24} md={12}>
                  <FormItem label="Harga Beli Max" {...formItemLayout}>
                   {getFieldDecorator("price", { initialValue: this.state.price })(
                     <InputNumber
                       disabled={true}
                       style={{ width: "100%" }}
                       formatter={value => `IDR ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                       parser={value => value.replace(/IDR\s?|(,*)/g, "")}
                     />,
                   )}
                 </FormItem>

                  <FormItem label="Harga Nett" {...formItemLayout}>
                    {getFieldDecorator("priceNegotiation", {
                      initialValue: this.state.negotiationPrice,
                    })(
                      <InputNumber
                        disabled={true}
                        style={{ width: "100%" }}
                        formatter={value => `IDR ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                        parser={value => value.replace(/IDR\s?|(,*)/g, "")}
                      />,
                    )}
                  </FormItem>

                  <FormItem label="Nama TNT" {...formItemLayout}>
                    {getFieldDecorator("priceNegotiator", {
                      initialValue: priceNegotiatorId ? PriceNegotiator.name : "",
                    })(
                      <Input disabled={true} />,
                    )}
                  </FormItem> 

                  <FormItem label="Catatan (SPV)" {...formItemLayout}>
                    {getFieldDecorator("negotiationNotes", {
                      initialValue: this.state.negotiationNotes,
                    })(<Input.TextArea rows={4} disabled={true} />)}
                  </FormItem>
                </Col>

                <Col xs={24} md={12}>
                  <FormItem label="Harga Setelah Nego" {...formItemLayout}>
                    {getFieldDecorator("priceFromNegotiator", {
                      initialValue: this.state.priceFromNegotiator || 0,
                      rules: [{required: true, message: "Harga negosiasi"}]
                    })(
                      <InputNumber
                        style={{ width: "100%" }}
                        formatter={value => `IDR ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                        parser={value => value.replace(/IDR\s?|(,*)/g, "")}
                      />,
                    )}
                  </FormItem>
                  <FormItem label="Follow Up Status" {...formItemLayout}>
                    {console.log(this.state)}
                    {getFieldDecorator("TNTFollowUp", {initialValue:this.state.TNTFollowUp || "", rules: [{ required: true, message: "Follow Up Status is required" }]})(
                      <Select placeholder="Follow Up status">
                        <Option key="FU1" value="FU1">Follow Up 1</Option>
                        <Option key="FU2" value="FU2">Follow Up 2</Option>
                        <Option key="FU3"value="FU3">Follow Up 3</Option>
                      </Select>,
                    )}
                  </FormItem>
                  <FormItem label="Catatan (TNT)" {...formItemLayout}>
                    {getFieldDecorator("priceNegotiatorNotes", {
                      initialValue: this.state.priceNegotiatorNotes || "",
                    })(<Input.TextArea rows={4}/>)}
                  </FormItem>
                  <FormItem label="Tanggal Pengambilan" {...formItemLayout}>
                    {getFieldDecorator("collectionDate", {
                      initialValue: this.state.collectionDate
                        ? moment(this.state.collectionDate, "YYYY-MM-DDTHH:mm")
                        : moment(),
                    })(<DatePicker style={{ width: "100%" }}/>)}
                  </FormItem>
                </Col>
              </Row>
              <Row style={{ float: "right" }}>
                <Button type="primary" onClick={() => this.saveAsDraft()}>
                  Save as Draft
                </Button>
                <Button type="primary" htmlType="submit" style={{marginLeft: 8}}>
                  Submit
                </Button>
              </Row>
            </Form>
          </Card>
        </Row>
      </Card>
    ) : (<Empty/>) ;
  }
}

const FormOffering = Form.create()(OfferingDetail);
const mapStateToProps = ({ Auth }) => ({ Auth });

export default connect(mapStateToProps)(FormOffering);



// WEBPACK FOOTER //
// src/components/Dashboard/InternalBidding/TNT/NegotiationUpdate.js